import axios from "axios";
import {
  awsUrl,
  aspNetUrl,
  newApiBaseUrl,
  newS3BucketUrl,
} from "../../axiosInstance";
import * as actionType from "../store/action";
import showAlert from "./ShowAlert";
import { setPreload } from "./CartsOpen";

export const reloadFunc = () => ({
  type: "RELOAD_SALES_START",
});

const normalizeProducts = (rawData) => {
  const seenGtins = new Set();

  return rawData
    .map((item) => {
      const actualItem = Array.isArray(item) ? item[0] : item;
      const product = actualItem?.product;

      if (!product || seenGtins.has(product.gtin)) return null;
      seenGtins.add(product.gtin);
      product.media = product.media?.length ? product.media : [{ path: "" }];

      return actualItem;
    })
    .filter(Boolean);
};
export const reloedFunc = () => (dispatch) =>
  dispatch({ type: actionType.RELOED });

export const createProduct = (data) => {
  return axios.post(`${awsUrl}/v1/products`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
    },
  });
};

export const getOrphanProducts = () => {
  return (dispatch) => {
    axios
      .get(`${awsUrl}/v1/products/category/orphan`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        dispatch({
          type: actionType.SET_PRODUCTS,
          payload: {
            items: x.data,
          },
        });
      })
      .catch((e) => console.log(e));
  };
};

let isFetchingSales = false;

export const getSales = (stationId) => async (dispatch) => {
  if (isFetchingSales || !stationId) return;

  try {
    isFetchingSales = true;
    const { data: promotions } = await axios.get(
      `${newApiBaseUrl}/promotions`,
      {
        params: { branch: stationId },
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      },
    );
    const promosArray = Array.isArray(promotions) ? promotions : [];
    const gtinsList = [
      ...new Set(promosArray.map((p) => p.gtin).filter((g) => g)),
    ];

    if (!gtinsList.length) {
      return dispatch({
        type: actionType.SET_PRODUCTS,
        payload: { items: [] },
      });
    }

    const productIdsString = gtinsList.map((g) => `${g}-000`).join(",");

    const { data: rawProducts } = await axios.get(
      `${newApiBaseUrl}/admin/products`,
      {
        params: {
          branch: stationId,
          productIds: productIdsString,
        },
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      },
    );

    const items = Array.isArray(rawProducts) ? rawProducts : [];

    dispatch({
      type: actionType.SET_PRODUCTS,
      payload: { items: items },
    });

    return { data: promosArray };
  } catch (e) {
    console.error("Failed to fetch products:", e);
    dispatch({ type: actionType.SET_PRODUCTS, payload: { items: [] } });
    throw e;
  } finally {
    isFetchingSales = false;
  }
};
export const getByMkt = (mkt, stationId) => {
  return (dispatch) => {
    axios
      .get(`${awsUrl}/v1/products/${mkt}`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) =>
        dispatch({ type: actionType.SET_SELCTED_PRODUCT, data: x.data }),
      )
      .catch(() => console.log("error"));
  };
};

export const getItemsPerCategoryCount = (id, stationId, count, mkt) => {
  return axios.get(
    `${awsUrl}/v1/products/${mkt}/category/${id}/count?stationId=${stationId}&count=${count}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
      },
    },
  );
};
export const getItemsPerCategory = (slug, stationId) => {
  return axios.get(`${newApiBaseUrl}/categories/${slug}/products`, {
    params: {
      branch: stationId,
    },
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getItemsPerCategoryPgw = (slug, branch) => {
  return axios.get(
    `${newApiBaseUrl}/categories/${slug}
`,
    {
      params: {
        branch: branch,
      },
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const getItemsPerCategoryDispatch = (
  id,
  stationId,
  adminToCustomer = null,
) => {
  return (dispatch) => {
    getItemsPerCategory(id, stationId, adminToCustomer)
      .then((x) => {
        const items = x.data;
        items.sort(
          (a, b) => a.CategoryFullOrderNumber - b.CategoryFullOrderNumber,
        );
        dispatch({
          type: actionType.SET_PRODUCTS,
          payload: {
            items,
            //: x.data.sort((a, b) => { return a.CategoryFullOrderNumber - b.CategoryFullOrderNumber })
          },
        });
      })
      .catch(() => console.log("error"));
  };
};

let cancelToken;
export const getItemsPerWord = (word, branch, fields) => {
  return (dispatch) => {
    if (cancelToken) {
      cancelToken.cancel("Cancelled previous request");
    }

    cancelToken = axios.CancelToken.source();

    dispatch({ type: actionType.RELOED });

    return axios
      .get(`${newApiBaseUrl}/products/search`, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
          "X-Tenant": localStorage.tenant || "hamazon",
        },
        params: {
          q: word,
          branch,
          fields,
        },
        cancelToken: cancelToken.token,
      })
      .then((res) => {
        const items = res.data?.results || [];
        console.log(items);

        dispatch({
          type: actionType.SET_PRODUCTS,
          payload: { items: { products: items, isFamily: false } },
        });
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log("Request cancelled:", err.message);
        } else {
          console.error("getItemsPerWord error", err);
          dispatch({
            type: actionType.SET_PRODUCTS,
            payload: { items: [] },
          });
        }
      });
  };
};

export const UpdateSort = (data, stationId, adminToCustomer) => {
  return (dispatch) => {
    axios
      .put(`${awsUrl}/v1/products/sort`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
        },
      })
      .then((response) => {
        dispatch(
          getItemsPerCategoryDispatch(
            data.CategoryId,
            stationId,
            adminToCustomer,
          ),
        );
      })
      .catch((error) => {
        console.error("Error updating product sort:", error);
        showAlert("עדכון הסדר נכשל, נסה שוב.");
      });
  };
};

export const UpdateProduct = (data) => {
  return axios.put(`${awsUrl}/v1/products`, data, {});
};
export const AddProductToCategory = (slug, productId, stationId) => {
  return (dispatch) => {
    dispatch(setPreload(true));
    const data = {
      productId,
      branch: stationId,
      kind: "append",
    };
    const config = {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    };

    return axios
      .post(`${newApiBaseUrl}/admin/categories/${slug}/products`, data, config)
      .then((res) => {
        dispatch({
          type: actionType.ADD_NEW_PRODUCT,
          payload: res.data,
        });
        return res;
      })
      .catch((err) => {
        console.error("Full Error Object:", err.response?.data);
        throw err;
      })
      .finally(() => dispatch(setPreload(false)));
  };
};
export const checkProductExistence = (gtin, branch) => {
  const productId = `${gtin}-000`;
  return axios.get(`${newApiBaseUrl}/admin/products`, {
    params: {
      branch: branch,
      productIds: productId,
    },
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};
export const GetProductEditMini = (mkt) => {
  return axios.get(`${awsUrl}/v1/products/${mkt}/mini`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const SetImgActive = (Mkt, imgDataId, imgName) => {
  return (dispatch) =>
    axios
      .put(
        `${awsUrl}/v1/products/image`,
        {
          Mkt,
          ImgId: imgDataId,
        },
        {
          headers: {
            Authorization: `bearer ${localStorage.jwtToken}`,
          },
        },
      )
      .then((x) =>
        dispatch({ type: actionType.SET_UPDAATE_SELCED_PRODUCT, imgName }),
      );
};

export const GetImgUrlProduct = (mkt) => {
  return axios.get(`${awsUrl}/v1/products/${mkt}/image`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const GetProducts = () => {
  return (dispatch) =>
    axios
      .get(`${awsUrl}/v1/products`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) =>
        dispatch({ type: actionType.SET_ALL_SELECTED_PRODUCT, data: x.data }),
      );
};

export const toggleFilter = (id, typeName) => {
  return (dispatch) => {
    dispatch({ type: actionType.TOGGLE_FILTER, payload: { id, typeName } });
  };
};

export const clearFilters = () => {
  return (dispatch) => {
    dispatch({ type: actionType.CLEAR_FILTER });
  };
};

export const clearSearch = () => {
  return (dispatch) => {
    dispatch({ type: actionType.DELETE_SEARCH });
  };
};

export const search = (word) => {
  return (dispatch) => {
    dispatch({ type: actionType.SET_SEARCH_PRODUCT, payload: word.trim() });
  };
};

export const setFilterSort = (bool) => {
  return (dispatch) => {
    dispatch({ type: actionType.SET_FILTER_SORT, payload: bool });
  };
};

export const getBrandNameById = (brandId) => {
  return axios.get(`${aspNetUrl}Product/GetBrandNameById?brandId=${brandId}`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const setPrice = (branch, gtin, price) => {
  const data = {
    branch,
    gtin,
    price,
    retailer: "Hamazon",
  };

  axios
    .put(`${newApiBaseUrl}/admin/productprices`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error(
        "Error updating price:",
        error.response ? error.response.data : error.message,
      );
    });
};

export const setSailPrice = (data) => {
  axios
    .put(`${newApiBaseUrl}/admin/productpromotions`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error(
        "Error updating price:",
        error.response ? error.response.data : error.message,
      );
    });
};

// export const getSails = async (branchId) => {
//   try {
//     const response = await axios.get(`${newApiBaseUrl}/admin/promotions`);
//     console.log("response from server", response);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching data:", error);
//   }
// };

export const getProductsByCategory = (branch, productId) => {
  return (dispatch) => {
    axios
      .get(`${newApiBaseUrl}/admin/products`, {
        params: {
          branch: branch,
          productIds: productId,
          fields:
            "product_id,gtin,name,variant,brand,sub_brand,user_company,media,description,kosher_supervision,weight_details,weight_jump,exchange_provider,price_control,view_brand,branch,vat_exempt,pricing,show_out_of_stock,logistics_details",
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      })
      .then((x) => {
        dispatch({
          type: actionType.SET_PRODUCT_PRICING,
          data: { Product: x.data[0].pricing },
        });
        dispatch({
          type: actionType.SET_SELCTED_PRODUCT,
          data: { Product: x.data[0].product },
        });
        dispatch({
          type: actionType.SET_PRODUCT_CATEGORIES,
          data: x.data[0].categories,
        });
      })
      .catch(() => console.log("error"));
  };
};

export const setProducts = (products) => {
  return (dispatch) => {
    dispatch({ type: actionType.SET_PRODUCTS, payload: { items: products } });
  };
};

export const updateProductFields = (branch, productId, tochange) => {
  const data = {
    branch: branch,
    ...tochange,
  };
  return axios.put(`${newApiBaseUrl}/admin/products/${productId}`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getProductByGtin = (gtin, branch) => {
  return (dispatch) => {
    if (cancelToken) {
      cancelToken.cancel("Cancelled previous request");
    }
    cancelToken = axios.CancelToken.source();

    dispatch({ type: actionType.RELOED });

    return axios
      .get(`${newApiBaseUrl}/admin/products`, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
        params: { gtin, branch },
        cancelToken: cancelToken.token,
      })
      .then((res) => {
        const itemsWithCategory = res.data.filter(
          (item) =>
            Array.isArray(item.categories) && item.categories.length > 0,
        );

        dispatch({
          type: actionType.SET_PRODUCTS,
          payload: { items: itemsWithCategory },
        });

        if (itemsWithCategory[0]?.categories) {
          dispatch({
            type: actionType.SET_PRODUCT_CATEGORIES,
            data: itemsWithCategory[0].categories,
          });
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log("Request cancelled:", err.message);
        } else {
          console.error("getProductByGtin error", err);
          dispatch({ type: actionType.SET_PRODUCTS, payload: { items: [] } });
        }
      });
  };
};

export const changeProdRank = (slug, productId, data) => {
  return axios.patch(
    `${newApiBaseUrl}/admin/categories/${slug}/products/${productId}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const updateProductStatus = (productId, slug, status, branch) => {
  console.log("Updating product status:", { productId, slug, status });

  return axios.put(
    `${newApiBaseUrl}/products/${productId}/${slug}/update-status`,
    { status, branch },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};
